'use client';

import { useNavigate } from 'react-router-dom';

import { Close, SearchMenu } from '@zoomit/icons';
import { IconButton, Link } from '@zoomit/primitives';
import { MenuProfileMobile, OriginURL, useLogout } from '@zoomit/web-kit';
import { cssVar, theme } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../../hooks/useWebKitCustomization';
import MobileNotification from '../../notification/MobileNotification';

type Props = {
  onCloseMenu(): void;
};

const DefaultMenuProfileRouteMobile = (props: Props) => {
  const { onCloseMenu } = props;

  const basePath = useWebKitCustomization((settings) => settings.basePath);
  const tenantLogoRenderer = useWebKitCustomization((settings) => settings.tenantLogoRenderer);
  const navigate = useNavigate();
  const { isLoading: signOutLoading, mutate: handleSignOut } = useLogout();

  return (
    <div>
      <header
        className={
          'bg-background2 border-b-grey6 sticky top-0 z-[100] flex w-full items-center justify-between border-b px-4 py-[13px] transition-all duration-200'
        }
      >
        <IconButton disabled={signOutLoading} onClick={() => navigate('/home')}>
          <SearchMenu fill={cssVar(theme.grey3)} size="lg" />
        </IconButton>

        <Link href={`${OriginURL}/${basePath}`} style={{ display: 'flex' }}>
          {tenantLogoRenderer({ fill: cssVar(theme.text) })}
        </Link>

        <IconButton disabled={signOutLoading} onClick={onCloseMenu}>
          <Close fill={cssVar(theme.grey3)} size="xl" />
        </IconButton>
      </header>

      <MenuProfileMobile signOutLoading={signOutLoading} handleSignOut={handleSignOut} />
      <MobileNotification onClose={onCloseMenu} />
    </div>
  );
};

export default DefaultMenuProfileRouteMobile;
